<template lang="pug">
.group-role
  v-row
    v-col(cols="3")
      v-autocomplete(
        v-model="group",
        :items="filteredGroups",
        item-text="path",
        :label="$t('Common.selectEntity', { entity: $tc('BusinessScope._name', 1) })",
        return-object,
        :error-messages="errorMessagesGroups",
        v-bind="{ loading }",
      )
        template(v-slot:append)
          v-icon(color="primary") mdi-menu-down
    v-col(cols="2")
      v-select(
        v-model="role",
        :items="roles",
        item-text="name",
        :label="$t('Common.selectEntity', { entity: $tc('Role._name', 1) })",
        return-object,
        :error-messages="errorMessagesRoles",
        v-bind="{ loading }",
      )
        template(v-slot:append)
          v-icon(color="primary") mdi-menu-down
    v-col(cols="2")
      v-autocomplete.primary--text(
        v-model="partyGroup",
        :items="partyGroups",
        :item-text="'name'",
        :label="$t('Common.selectEntity', { entity: $tc('GroupParty._name', 1) })",
        return-object,
        :error-messages="errorMessagesParties",
        v-bind="{ loading }",
      )
        template(v-slot:append)
          v-icon(color="primary") mdi-menu-down
    v-col(cols="2")
      v-autocomplete.primary--text(
        v-model="taskGroup",
        :items="taskGroups",
        :item-text="'name'",
        :label="$t('Common.selectEntity', { entity: $tc('GroupTask._name', 1) })",
        return-object,
        :error-messages="errorMessagesTasks",
        v-bind="{ loading }",
      )
      template(v-slot:append)
        v-icon(color="primary") mdi-menu-down
    v-col(cols="2")
      g-btn.background.mt-3(color="primary", @click="addGR", :disabled="!completeGR", text) {{ $t('groupRole.addAccess') }}

  v-row(v-if="completeGR && !emptyErrors")
    .v-messages.error--text {{ $t('groupRole.errorAdd') }}

  v-row(wrap)
    v-col(cols="12")
      .chips-row(v-for="(urg, index) in scopeChips", :key="index")
        v-chip.font-weight-medium.ma-1(color="primary", text-color="primaryHover", label, outlined) {{getChipText(urg)}}
          v-btn.ml-1(icon='', x-small, color='primary', plain="true", @click="removeGR(urg)")
            v-icon mdi-close
</template>

<style scoped>
  .chips-row {
    display: inline-block;
  }
</style>

<script>

export default {
  props: {
    value: {},
    errorMessages: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
    roles: {
      type: Array,
      default: () => [],
    },
    partyGroups: {
      type: Array,
      default: () => [],
    },
    taskGroups: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    instance: null
  },

  data: () => ({
    group: null,
    taskGroup: null,
    partyGroup: null,
    role: null,
    defaultBusinessScope: null
  }),

  watch: {
  },

  computed: {
    // Error Message shows only if there is no group.
    errorMessagesGroups() {
      return this.group ? [] : this.errorMessages;
    },
    errorMessagesRoles() {
      return this.role ? [] : this.errorMessages;
    },
    errorMessagesParties() {
      return this.partyGroup ? [] : this.errorMessages;
    },
    errorMessagesTasks() {
      return this.taskGroup ? [] : this.errorMessages;
    },
    emptyErrors() {
      return _.isEmpty(this.errorMessages);
    },
    completeGR() {
      return this.group && this.role;
    },
    // selectedGroups() {
    //   return _.map(this.value, ({ businessScopeId }) => ({ id: businessScopeId }));
    // },
    valGroupsIds() {
      return _.chain(this.value).filter(x => x.uRoleBS.entityState !== 2).map('uRoleBS.businessScopeId').value();
    },
    filteredGroups() {
      return _.chain(this.groups).filter(({ id }) => !_.includes(this.valGroupsIds, id)).value();
    },
    groupsIds() {
      return _.map(this.groups, 'id');
    },
    scopeChips() {
      return _.chain(this.value)
        .filter(({ uRoleBS }) => _.includes(this.groupsIds, uRoleBS.businessScopeId))
        .filter(({ uRoleBS }) => uRoleBS.entityState !== 2 )
        .filter(({ uRoleBS }) => uRoleBS.deletedAt == null )
        .value();
    },

  },

  methods: {
    roleName(id) {
      return _.chain(this.roles).find(scope => scope.id === id).thru(o => o ? o.name : '').value();
    },
    groupName(id) {
      return _.chain(this.groups).find(scope => scope.id === id).thru(o => o ? o.path : '').value();
    },
    partyGroupName(id) {
      return _.chain(this.partyGroups).find(scope => scope.id === id).thru(o => o ? o.name : '').value();
    },
    taskGroupName(id) {
      return _.chain(this.taskGroups).find(scope => scope.id === id).thru(o => o ? o.name : '').value();
    },
    addGR() {
      //Add into value
      this.$emit('input', [...(this.value || []), {
        uRoleBS: {
          _Entity: 'UserRoleBusinessScope',
          roleId: this.role.id,
          businessScopeId: this.group.id,
          entityState: 4
        },
        partyGroup: this.partyGroup ? {
          group: {
            _Entity: 'GroupPartyUser',
            id: this.partyGroup.id,
            entity: 'GroupPartyUser',
            businessScopeId: this.group.id,
          },
          entityState: 4,
          entity: 'GroupPartyUser',
          businessScopeId: this.group.id,
        } : null,
        taskGroup: this.taskGroup ? {
          group: {
            _Entity: 'GroupTaskUser',
            id: this.taskGroup.id,
            entity: 'GroupTaskUser',
            businessScopeId: this.group.id,
          },
          entityState: 4,
          entity: 'GroupTaskUser',
          businessScopeId: this.group.id,
        } : null
      }]);
      //Clear selections
      this.group = null;
      this.role = null;
      this.partyGroup = null;
      this.taskGroup = null;
    },
    removeGR(val) { // TODO
      if( val.uRoleBS.entityState === 4
        && ((val.partyGroup == null || val.partyGroup.entityState === 4) || (val.taskGroup == null || val.taskGroup.entityState === 4)) ) {
        let temp = [...this.value];
        this.$emit('input', _.differenceWith(temp, [val], _.isEqual));
      } else {
        if (val.partyGroup != null) {
          val.partyGroup.entityState = 2;
        }
        if(val.taskGroup != null) {
          val.taskGroup.entityState = 2;
        }
        val.uRoleBS.entityState = 2;
      }
    },
    getChipText(scopeValues) {
      // 1. Business Scope
      let businessScopeText = this.groupName(scopeValues.uRoleBS.businessScopeId);
      // 2. Role
      let roleText = this.roleName(scopeValues.uRoleBS.roleId);
      // 3. Group Party
      let groupText = '';
      if(scopeValues.partyGroup != null && scopeValues.partyGroup.group.id > 0)
      {
        groupText = ' | ' + this.partyGroupName(scopeValues.partyGroup.group.id);
      }
      if(scopeValues.taskGroup != null && scopeValues.taskGroup.group.id > 0)
      {
        groupText += ' | ' + this.taskGroupName(scopeValues.taskGroup.group.id);
      }

      return businessScopeText + ' | ' + roleText + groupText;
    }
  },
  async created () {
    if(this.instance.businessScope)
      this.defaultBusinessScope = this.instance.businessScope.path
  },
  async mounted () {

  }
}
</script>
